export default "__VITE_ASSET__l7SygiWy__"